export const buttonsInfoConfig = {
  lawmaking: {
    id: 'lawmaking',
    name: {
      ua: 'ÐÐ°ÐºÐ¾Ð½Ð¾Ð´Ð°Ð²ÑÑÐ²Ð¾ Ð£ÐºÑÐ°ÑÐ½Ð¸',
      ru: 'ÐÐ°ÐºÐ¾Ð½Ð¾Ð´Ð°ÑÐµÐ»ÑÑÑÐ²Ð¾ Ð£ÐºÑÐ°Ð¸Ð½Ñ'
    },
    ico: 'lawmaking',
    url: '/resource/legislation',
    helpUrl: 'HP160044',
    crmAlias: 'maindocs_51',
    crmAliasHide: 'module_legislation_hide'
  },
  advocatebase: {
    id: 'advocatebase',
    name: {
      ua: 'ÐÐ°Ð·Ð° Ð·Ð½Ð°Ð½Ñ',
      ru: 'ÐÐ°Ð·Ð° Ð·Ð½Ð°Ð½Ð¸Ð¹'
    },
    ico: 'lawmaking',
    url: '/resource/legislation?from=advocate',
    helpUrl: 'HP160014',
    crmAlias: 'maindocs_51',
    crmAliasHide: 'module_legislation_hide'
  },
  situationBusiness: {
    id: 'situationBusiness',
    name: {
      ua: 'Ð¡Ð¸ÑÑÐ°ÑÑÑ',
      ru: 'Ð¡Ð¸ÑÑÐ°ÑÐ¸Ð¸'
    },
    ico: 'situation',
    type: {
      ua: 'Ð´Ð»Ñ Ð±ÑÐ·Ð½ÐµÑÑ',
      ru: 'Ð´Ð»Ñ Ð±Ð¸Ð·Ð½ÐµÑÐ°'
    },
    url: '/resource-grid/cases_for_business',
    helpUrl: 'HP160041',
    crmAlias: 'cases_for_business',
    crmAliasHide: ''

  },
  securityBusiness: {
    id: 'securityBusiness',
    name: {
      ua: 'ÐÐ¸ÑÑÐµÑÑÐ²Ð¾ Ð¾Ð±Ð¾ÑÐ¾Ð½Ð¸',
      ru: 'ÐÑÐºÑÑÑÑÐ²Ð¾ Ð¾Ð±Ð¾ÑÐ¾Ð½Ñ'
    },
    ico: 'security',
    url: '/resource/security',
    helpUrl: 'HP160051',
    crmAlias: 'business_safety_law',
    crmAliasHide: 'business_safety_hide'
  },
  monitoring: {
    id: 'monitoring',
    name: {
      ua: 'ÐÐ¾Ð½ÑÑÐ¾ÑÐ¸Ð½Ð³ ÐºÐ¾Ð½ÑÑÐ°Ð³ÐµÐ½ÑÑÐ²',
      ru: 'ÐÐ¾Ð½Ð¸ÑÐ¾ÑÐ¸Ð½Ð³ ÐºÐ¾Ð½ÑÑÐ°Ð³ÐµÐ½ÑÐ¾Ð²'
    },
    ico: 'monitoring',
    url: '/contractor',
    helpUrl: 'HP160014',
    crmAlias: '',
    crmAliasHide: ''
  },
  mapNews: {
    id: 'mapNews',
    name: {
      ua: 'ÐÐ¾Ð²Ð°ÑÑÑ',
      ru: 'ÐÐ¾Ð²Ð°ÑÐ¸Ð¸'
    },
    ico: 'map-new',
    url: '/innovations',
    helpUrl: 'HP160046',
    crmAlias: 'novation_map_access',
    crmAliasHide: ''
  },
  authorityUa: {
    id: 'authorityUa',
    name: {
      ua: 'ÐÐ»Ð°Ð´Ð° Ð£ÐºÑÐ°ÑÐ½Ð¸',
      ru: 'ÐÐ»Ð°ÑÑÑ Ð£ÐºÑÐ°Ð¸Ð½Ñ'
    },
    ico: 'authority-ua',
    url: '/authority',
    helpUrl: 'HP160049',
    crmAlias: 'ukraine_goverment_access',
    crmAliasHide: ''
  },
  lawProject: {
    id: 'lawProject',
    name: {
      ua: 'ÐÐ°ÐºÐ¾Ð½Ð¾Ð¿ÑÐ¾ÐµÐºÑÐ¸',
      ru: 'ÐÐ°ÐºÐ¾Ð½Ð¾Ð¿ÑÐ¾ÐµÐºÑÑ'
    },
    ico: 'law-projects',
    url: '/resource/draft_laws',
    helpUrl: 'HP160034',
    crmAlias: 'draft_laws',
    crmAliasHide: ''
  },
  patterns: {
    id: 'patterns',
    name: {
      ua: 'Ð¢Ð¸Ð¿Ð¾Ð²Ñ Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÐ¸ ÑÐ° ÑÐ°Ð±Ð»Ð¾Ð½Ð¸',
      ru: 'Ð¢Ð¸Ð¿Ð¾Ð²ÑÐµ Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÑ Ð¸ ÑÐ°Ð±Ð»Ð¾Ð½Ñ'
    },
    ico: 'patterns',
    url: '/resource/contracts_and_templates',
    helpUrl: 'HP160047',
    crmAlias: 'contracts&templates',
    crmAliasHide: ''
  },
  forms: {
    id: 'forms',
    name: {
      ua: 'Ð¤Ð¾ÑÐ¼Ð¸ ÑÐ° Ð±Ð»Ð°Ð½ÐºÐ¸',
      ru: 'Ð¤Ð¾ÑÐ¼Ñ Ð¸ Ð±Ð»Ð°Ð½ÐºÐ¸'
    },
    ico: 'forms',
    url: '/resource/forms_and_blanks',
    helpUrl: 'HP160028',
    crmAlias: 'forms&blanks',
    crmAliasHide: ''
  },
  consultations: {
    id: 'consultations',
    name: {
      ua: 'ÐÐ¾Ð½ÑÑÐ»ÑÑÐ°ÑÑÑ Ð¾ÑÐ¾Ð±Ð¸ÑÑÐ¾Ð³Ð¾ ÐµÐºÑÐ¿ÐµÑÑÐ°',
      ru: 'ÐÐ¾Ð½ÑÑÐ»ÑÑÐ°ÑÐ¸Ð¸ Ð»Ð¸ÑÐ½Ð¾Ð³Ð¾ ÑÐºÑÐ¿ÐµÑÑÐ°'
    },
    ico: 'consultation',
    url: '/resource/advice_for_accountant',
    helpUrl: 'HP160029',
    crmAlias: 'advice_for_accountant',
    crmAliasHide: ''
  },
  lawPictures: {
    id: 'lawPictures',
    name: {
      ua: 'ÐÑÐ°Ð²Ð¾Ð²Ð° ÐºÐ°ÑÑÐ¸Ð½Ð° Ð´Ð½Ñ',
      ru: 'ÐÑÐ°Ð²Ð¾Ð²Ð°Ñ ÐºÐ°ÑÑÐ¸Ð½Ð° Ð´Ð½Ñ'
    },
    ico: 'law-picture',
    url: 'ipas/lawnews/list?type=ALL&condition=day',
    helpUrl: 'HP160045',
    crmAlias: 'news_biz',
    crmAliasHide: ''
  },
  termVocabulary: {
    id: 'termVocabulary',
    name: {
      ua: 'Ð¢ÐµÑÐ¼ÑÐ½Ð¾Ð»Ð¾Ð³ÑÑÐ½Ð¸Ð¹ ÑÐ»Ð¾Ð²Ð½Ð¸Ðº',
      ru: 'Ð¢ÐµÑÐ¼Ð¸Ð½Ð¾Ð»Ð¾Ð³Ð¸ÑÐµÑÐºÐ¸Ð¹ ÑÐ»Ð¾Ð²Ð°ÑÑ'
    },
    ico: 'term-vocabulary',
    url: '/dictionary',
    helpUrl: 'HP160039',
    crmAlias: 'glossary',
    crmAliasHide: ''
  },
  bankruptcy: {
    id: 'bankruptcy',
    name: {
      ua: 'ÐÐ°Ð½ÐºÑÑÑÑÑÐ²Ð¾',
      ru: 'ÐÐ°Ð½ÐºÑÐ¾ÑÑÑÐ²Ð¾'
    },
    ico: 'bankruptcy',
    url: '/resource/bankrupcy',
    helpUrl: 'HP160048',
    crmAlias: 'bankrupcy',
    crmAliasHide: ''

  },
  community: {
    id: 'community',
    name: {
      ua: 'ÐÐ¾Ð¼\'ÑÐ½ÑÑÑ',
      ru: 'ÐÐ¾Ð¼ÑÑÐ½Ð¸ÑÐ¸'
    },
    ico: 'community',
    url: 'http://forum.liga.net/',
    helpUrl: 'HP160014',
    crmAlias: '',
    crmAliasHide: ''
  },
  reestrUa: {
    id: 'reestrUa',
    name: {
      ua: 'Ð ÐµÑÑÑÑÐ¸ Ð£ÐºÑÐ°ÑÐ½Ð¸',
      ru: 'Ð ÐµÐµÑÑÑÑ Ð£ÐºÑÐ°Ð¸Ð½Ñ'
    },
    ico: 'reestr',
    url: '/registers/list',
    helpUrl: 'HP160014',
    crmAlias: '',
    crmAliasHide: ''
  },
  situationAccountant: {
    id: 'situationAccountant',
    name: {
      ua: 'Ð¡Ð¸ÑÑÐ°ÑÑÑ',
      ru: 'Ð¡Ð¸ÑÑÐ°ÑÐ¸Ð¸'
    },
    ico: 'situation',
    type: {
      ua: 'Ð´Ð»Ñ Ð±ÑÑÐ³Ð°Ð»ÑÐµÑÐ°',
      ru: 'Ð´Ð»Ñ Ð±ÑÑÐ³Ð°Ð»ÑÐµÑÐ°'
    },
    url: '/resource-grid/cases_for_accountant',
    helpUrl: 'HP160027',
    crmAlias: 'cases_for_accountant',
    crmAliasHide: ''
  },
  situationAccountant_b_mini: {
    id: 'situationAccountant_b_mini',
    name: {
      ua: 'ÐÐ£Ð¥ÐÐÐÐ¢ÐÐ  ÐÐÐÐ¢',
      ru: 'ÐÐ£Ð¥ÐÐÐÐ¢ÐÐ  ÐÐÐÐ¢'
    },
    ico: 'situation-b-mini',
    type: {
      ua: '',
      ru: ''
    },
    url: '/resource-grid/cases_for_accountant',
    helpUrl: 'HP160057',
    crmAlias: 'b_mini',
    crmAliasHide: ''
  },
  calendarAccountant: {
    id: 'calendarAccountant',
    name: {
      ua: 'ÐÐ°Ð»ÐµÐ½Ð´Ð°Ñ Ð±ÑÑÐ³Ð°Ð»ÑÐµÑÐ°',
      ru: 'ÐÐ°Ð»ÐµÐ½Ð´Ð°ÑÑ Ð±ÑÑÐ³Ð°Ð»ÑÐµÑÐ°'
    },
    ico: 'calendar-accountant',
    url: '/calendar/accountant',
    helpUrl: 'HP160030',
    crmAlias: 'calendar_accountant_access',
    crmAliasHide: ''
  },
  taxBase: {
    id: 'taxBase',
    name: {
      ua: 'ÐÐ°Ð·Ð° Ð¿Ð¾Ð´Ð°ÑÐºÐ¾Ð²Ð¸Ñ Ð·Ð½Ð°Ð½Ñ',
      ru: 'ÐÐ°Ð·Ð° Ð½Ð°Ð»Ð¾Ð³Ð¾Ð²ÑÑ Ð·Ð½Ð°Ð½Ð¸Ð¹'
    },
    ico: 'tax-base',
    url: '/resource/bnz',
    helpUrl: 'HP160031',
    crmAlias: 'taxation_knowlege_base',
    crmAliasHide: ''
  },
  situationLawyer: {
    id: 'situationLawyer',
    name: {
      ua: 'Ð¡Ð¸ÑÑÐ°ÑÑÑ',
      ru: 'Ð¡Ð¸ÑÑÐ°ÑÐ¸Ð¸'
    },
    ico: 'situation',
    type: {
      ua: 'Ð´Ð»Ñ ÑÑÐ¸ÑÑÐ°',
      ru: 'Ð´Ð»Ñ ÑÑÐ¸ÑÑÐ°'
    },
    url: '/resource-grid/cases_for_lawyer',
    helpUrl: 'HP160033',
    crmAlias: 'cases_for_lawyer',
    crmAliasHide: ''
  },
  calendarLawyer: {
    id: 'calendarLawyer',
    name: {
      ua: 'ÐÐ°Ð»ÐµÐ½Ð´Ð°Ñ ÑÑÐ¸ÑÑÐ°',
      ru: 'ÐÐ°Ð»ÐµÐ½Ð´Ð°ÑÑ ÑÑÐ¸ÑÑÐ°'
    },
    ico: 'calendar-lawyer',
    url: '/calendar/lawyer',
    helpUrl: 'HP160040',
    crmAlias: 'calendar_law_access',
    crmAliasHide: ''
  },
  courtPractice: {
    id: 'courtPractice',
    name: {
      ua: 'Ð¡ÑÐ´Ð¾Ð²Ð° Ð¿ÑÐ°ÐºÑÐ¸ÐºÐ°',
      ru: 'Ð¡ÑÐ´ÐµÐ±Ð½Ð°Ñ Ð¿ÑÐ°ÐºÑÐ¸ÐºÐ°'
    },
    ico: 'court-practice',
    url: '/resource/judicial_practice',
    helpUrl: 'HP160035',
    crmAlias: 'judicial_practice',
    crmAliasHide: ''
  },
  commentsCodex: {
    id: 'commentsCodex',
    name: {
      ua: 'ÐÐ¾Ð¼ÐµÐ½ÑÐ¾Ð²Ð°Ð½Ñ ÐºÐ¾Ð´ÐµÐºÑÐ¸',
      ru: 'ÐÐ¾Ð¼Ð¼ÐµÐ½ÑÐ¸ÑÐ¾Ð²Ð°Ð½Ð½ÑÐµ ÐºÐ¾Ð´ÐµÐºÑÑ'
    },
    ico: 'comments',
    url: '/resource/commented_codexes?id=T102456',
    // url: '/commented_codexes?sort_by=id&id=T102456',
    helpUrl: 'HP160037',
    crmAlias: 'commented_codexes',
    crmAliasHide: ''
  },
  practice: {
    id: 'practice',
    name: {
      ua: 'ÐÑÐ°ÐºÑÐ¸ÐºÑÐ¼Ð¸',
      ru: 'ÐÑÐ°ÐºÑÐ¸ÐºÑÐ¼Ñ'
    },
    ico: 'practice',
    url: '/practicums/list',
    helpUrl: 'HP160014',
    crmAlias: '',
    crmAliasHide: ''
  },
  consult: {
    id: 'consult',
    name: {
      ua: 'ÐÑÐ¾Ð±Ð¸ÑÑÐ¸Ð¹ ÐµÐºÑÐ¿ÐµÑÑ',
      ru: 'ÐÐ¸ÑÐ½ÑÐ¹ ÑÐºÑÐ¿ÐµÑÑ'
    },
    ico: 'consult',
    url: '/consultations',
    helpUrl: 'HP160014',
    crmAlias: '',
    crmAliasHide: ''
  },
  findLawyer: {
    id: 'findLawyer',
    name: {
      ua: 'ÐÐ½Ð°Ð¹ÑÐ¸ ÑÑÐ¸ÑÑÐ°',
      ru: 'ÐÐ°Ð¹ÑÐ¸ ÑÑÐ¸ÑÑÐ°'
    },
    ico: 'find-law',
    url: 'http://jurliga.ligazakon.ua/catalog.htm',
    helpUrl: 'HP160014',
    crmAlias: '',
    crmAliasHide: ''
  },
  europeanLegislation: {
    id: 'europeanLegislation',
    name: {
      ua: 'ÐÐ²ÑÐ¾Ð¿ÐµÐ¹ÑÑÐºÐµ Ð·Ð°ÐºÐ¾Ð½Ð¾Ð´Ð°Ð²ÑÑÐ²Ð¾',
      ru: 'ÐÐ²ÑÐ¾Ð¿ÐµÐ¹ÑÐºÐ¾Ðµ Ð·Ð°ÐºÐ¾Ð½Ð¾Ð´Ð°ÑÐµÐ»ÑÑÑÐ²Ð¾'
    },
    ico: 'btn-euro',
    url: '/resource/european_legislation',
    helpUrl: 'HP160038',
    crmAlias: 'european_legislation',
    crmAliasHide: ''
  },
  industry: {
    id: 'industry',
    name: {
      ua: 'ÐÐ°Ð»ÑÐ·Ñ ÐµÐºÐ¾Ð½Ð¾Ð¼ÑÐºÐ¸',
      ru: 'ÐÑÑÐ°ÑÐ»Ð¸ ÑÐºÐ¾Ð½Ð¾Ð¼Ð¸ÐºÐ¸'
    },
    ico: 'industry',
    url: '/resource/industry',
    helpUrl: 'HP170001',
    crmAlias: 'industry',
    crmAliasHide: '',
    isNew: true
  },
  business_schema: {
    id: 'business_schema',
    name: {
      ua: 'ÐÐ»Ð³Ð¾ÑÐ¸ÑÐ¼Ð¸ Ð´ÑÐ¹',
      ru: 'ÐÐ»Ð³Ð¾ÑÐ¸ÑÐ¼Ñ Ð´ÐµÐ¹ÑÑÐ²Ð¸Ð¹'
    },
    type: {
      ua: 'Ð´Ð»Ñ Ð±ÑÐ·Ð½ÐµÑÑ',
      ru: 'Ð´Ð»Ñ Ð±Ð¸Ð·Ð½ÐµÑÐ°'
    },
    ico: 'business_schema',
    url: '/resource/business_schema',
    helpUrl: 'HP170003',
    crmAlias: 'business_schema',
    crmAliasHide: '',
    isNew: true
  },
  accountant_and_law: {
    id: 'accountant_and_law',
    name: {
      ua: 'ÐÐ£Ð¥ÐÐÐÐ¢ÐÐ &ÐÐÐÐÐ',
      ru: 'ÐÐ£Ð¥ÐÐÐÐ¢ÐÐ &ÐÐÐÐÐ'
    },
    ico: 'accountant_and_law',
    url: '/resource/accountant_and_law',
    helpUrl: 'HP170004',
    crmAlias: 'accountant_and_law',
    crmAliasHide: ''
  },
  cases_for_hr: {
    id: 'cases_for_hr',
    name: {
      ua: 'Ð¡Ð¸ÑÑÐ°ÑÑÑ',
      ru: 'Ð¡Ð¸ÑÑÐ°ÑÐ¸Ð¸'
    },
    ico: 'situation',
    type: {
      ua: 'Ð´Ð»Ñ ÐºÐ°Ð´ÑÐ¾Ð²Ð¸ÐºÐ°',
      ru: 'Ð´Ð»Ñ ÐºÐ°Ð´ÑÐ¾Ð²Ð¸ÐºÐ°'
    },
    url: '/resource-grid/cases_for_hr',
    helpUrl: 'HP160042',
    crmAlias: 'cases_for_hr',
    crmAliasHide: ''
  },
  judicial_practice_for_acountant: {
    id: 'judicial_practice_for_acountant',
    name: {
      ua: 'Ð¡ÑÐ´Ð¾Ð²Ð° Ð¿ÑÐ°ÐºÑÐ¸ÐºÐ°',
      ru: 'Ð¡ÑÐ´ÐµÐ±Ð½Ð°Ñ Ð¿ÑÐ°ÐºÑÐ¸ÐºÐ°'
    },
    ico: 'judicial_practice_for_acountant',
    type: {
      ua: 'Ð´Ð»Ñ Ð±ÑÑÐ³Ð°Ð»ÑÐµÑÐ°',
      ru: 'Ð´Ð»Ñ Ð±ÑÑÐ³Ð°Ð»ÑÐµÑÐ°'
    },
    url: '/resource/judicial_practice_for_acountant',
    helpUrl: 'HP160032',
    crmAlias: 'judicial_practice_for_acountant',
    crmAliasHide: ''
  },
  calculator_vc: {
    id: 'calculator_vc',
    name: {
      ua: 'ÐÐ°Ð»ÑÐºÑÐ»ÑÑÐ¾Ñ Ð²ÑÐ´Ð¿ÑÑÑÐ¾Ðº',
      ru: 'ÐÐ°Ð»ÑÐºÑÐ»ÑÑÐ¾Ñ Ð¾ÑÐ¿ÑÑÐºÐ¾Ð²'
    },
    ico: 'calculator_vc',
    url: '/calculator/vc',
    helpUrl: 'HP160024',
    crmAlias: 'calculator_vc_access',
    crmAliasHide: ''
  },
  calculator_zp: {
    id: 'calculator_zp',
    name: {
      ua: 'ÐÐ°Ð»ÑÐºÑÐ»ÑÑÐ¾Ñ ÑÐ½Ð´ÐµÐºÑÐ°ÑÑÑ Ð·Ð°ÑÐ¿Ð»Ð°ÑÐ¸',
      ru: 'ÐÐ°Ð»ÑÐºÑÐ»ÑÑÐ¾Ñ Ð¸Ð½Ð´ÐµÐºÑÐ°ÑÐ¸Ð¸ Ð·Ð°ÑÐ¿Ð»Ð°ÑÑ'
    },
    ico: 'calculator_zp',
    url: '/calculator/zp',
    helpUrl: 'HP160023',
    crmAlias: 'calculator_zp_access',
    crmAliasHide: ''
  },
  instructions: {
    id: 'instructions',
    name: {
      ua: 'ÐÐ½ÑÑÑÑÐºÑÑÑ ÑÐ° ÑÐ°Ð±Ð»Ð¾Ð½Ð¸',
      ru: 'ÐÐ½ÑÑÑÑÐºÑÐ¸Ð¸ Ð¸ ÑÐ°Ð±Ð»Ð¾Ð½Ñ'
    },
    ico: 'instructions',
    type: {
      ua: 'Ð´Ð»Ñ ÐºÐ°Ð´ÑÐ¾Ð²Ð¸ÐºÐ°',
      ru: 'Ð´Ð»Ñ ÐºÐ°Ð´ÑÐ¾Ð²Ð¸ÐºÐ°'
    },
    url: '/resource/instructions',
    helpUrl: 'HP160043',
    crmAlias: 'instructions',
    crmAliasHide: ''
  },
  directories: {
    id: 'directories',
    name: {
      ua: 'ÐÐ¾Ð²ÑÐ´Ð½Ð¸ÐºÐ¸',
      ru: 'Ð¡Ð¿ÑÐ°Ð²Ð¾ÑÐ½Ð¸ÐºÐ¸'
    },
    ico: 'directories',
    url: '/resource/directories',
    helpUrl: 'HP160052',
    crmAlias: 'directories',
    crmAliasHide: ''
  },
  help: {
    id: 'help',
    name: {
      ua: 'ÐÑÐ¾ Ð¿ÑÐ¾Ð´ÑÐºÑ',
      ru: 'O Ð¿ÑÐ¾Ð´ÑÐºÑÐµ'
    },
    ico: '',
    url: '/resource/help',
    helpUrl: 'HP160014',
    crmAlias: '',
    crmAliasHide: ''
  },

  pravo: {
    id: 'pravo',
    name: {
      ua: 'ÐÑÐ°Ð²Ð¾ Ð£ÐºÑÐ°ÑÐ½Ð¸',
      ru: 'ÐÑÐ°Ð²Ð¾ Ð£ÐºÑÐ°Ð¸Ð½Ñ'
    },
    ico: 'pravo',
    url: '/resource/pravo',
    helpUrl: 'HP160014',
    crmAlias: 'pravo_access',
    crmAliasHide: 'pravo_hide'

  },
  bookmark: {
    id: 'bookmark',
    name: {
      ua: 'ÐÐ±ÑÐ°Ð½Ðµ',
      ru: 'ÐÐ·Ð±ÑÐ°Ð½Ð½Ð¾Ðµ'
    },
    ico: '',
    url: '/bookmark',
    helpUrl: 'HP160014',
    crmAlias: '',
    crmAliasHide: ''
  },
  dynamic: {
    id: 'dynamic',
    name: {
      ua: 'ÐÐ°Ð²ÑÐ³Ð°ÑÐ¾Ñ',
      ru: 'ÐÐ°Ð²Ð¸Ð³Ð°ÑÐ¾Ñ'
    },
    ico: '',
    url: '/dynamic',
    helpUrl: 'HP160014',
    crmAlias: '',
    crmAliasHide: ''
  },
  referent: {
    id: 'referent',
    name: {
      ua: 'Ð ÐµÑÐµÑÐµÐ½Ñ',
      ru: 'Ð ÐµÑÐµÑÐµÐ½Ñ'
    },
    ico: '',
    url: '/referent',
    helpUrl: 'HP160014',
    crmAlias: '',
    crmAliasHide: ''
  },
  reporting: {
    id: 'reporting',
    name: {
      ua: 'ÐÐ²ÑÑÐ½ÑÑÑÑ',
      ru: 'ÐÑÑÐµÑÐ½Ð¾ÑÑÑ'
    },
    ico: '',
    url: '/reporting',
    helpUrl: 'HP160014',
    crmAlias: 'ips_reporting',
    crmAliasHide: ''
  },
  requisites: {
    id: 'requisites',
    name: {
      ua: 'ÐÐ¾ÑÑÐº Ð·Ð° ÑÐµÐºÐ²ÑÐ·Ð¸ÑÐ°Ð¼Ð¸',
      ru: 'ÐÐ¾Ð¸ÑÐº Ð¿Ð¾ ÑÐµÐºÐ²Ð¸Ð·Ð¸ÑÐ°Ð¼'
    },
    ico: '',
    url: '/requisites',
    helpUrl: 'HP160014',
    crmAlias: '',
    crmAliasHide: ''
  },
  search: {
    id: 'search',
    name: {
      ua: 'ÐÐ¾ÑÑÐº Ð·Ð° ÑÐµÐºÑÑÐ¾Ð¼',
      ru: 'ÐÐ¾Ð¸ÑÐº Ð¿Ð¾ ÑÐµÐºÑÑÑ'
    },
    ico: 'search-page',
    url: '/search',
    helpUrl: 'HP160014',
    crmAlias: 'fulltext_search_access',
    crmAliasHide: ''
  },
  signinup: {
    id: 'signinup',
    name: {
      ua: 'ÐÐ²ÑÐ¾ÑÐ¸Ð·Ð°ÑÑÑ / Ð ÐµÑÑÑÑÐ°ÑÑÑ',
      ru: 'ÐÐ²ÑÐ¾ÑÐ¸Ð·Ð°ÑÐ¸Ñ / Ð ÐµÐ³Ð¸ÑÑÑÐ°ÑÐ¸Ñ'
    },
    ico: '',
    url: '/signinup/auth',
    helpUrl: 'HP160014',
    crmAlias: '',
    crmAliasHide: ''
  },
  standards: {
    id: 'standards',
    name: {
      ua: 'Ð¡ÑÐ°Ð½Ð´Ð°ÑÑÐ¸',
      ru: 'Ð¡ÑÐ°Ð½Ð´Ð°ÑÑÑ'
    },
    ico: '',
    url: '/standards',
    helpUrl: 'HP160014',
    crmAlias: '',
    crmAliasHide: ''
  },
  whatnew: {
    id: 'whatnew',
    name: {
      ua: 'ÐÐ¾Ð²Ñ Ð½Ð°Ð´ÑÐ¾Ð´Ð¶ÐµÐ½Ð½Ñ',
      ru: 'ÐÐ¾Ð²ÑÐµ Ð¿Ð¾ÑÑÑÐ¿Ð»ÐµÐ½Ð¸Ñ'
    },
    ico: '',
    url: '/whatnew',
    helpUrl: 'HP160014',
    crmAlias: '',
    crmAliasHide: ''
  },
  wiring: {
    id: 'wiring',
    name: {
      ua: 'ÐÑÑÐ³Ð°Ð»ÑÐµÑÑÑÐºÑ Ð¿ÑÐ¾Ð²Ð¾Ð´ÐºÐ¸',
      ru: 'ÐÑÑÐ³Ð°Ð»ÑÐµÑÑÐºÐ¸Ðµ Ð¿ÑÐ¾Ð²Ð¾Ð´ÐºÐ¸'
    },
    ico: 'wiring',
    url: '/wiring',
    helpUrl: 'HP160055',
    crmAlias: 'accounting_entries_access',
    crmAliasHide: ''
  },
  fines_calc: {
    id: 'fines_calc',
    name: {
      ua: 'ÐÐ°Ð»ÑÐºÑÐ»ÑÑÐ¾Ñ ÑÑÑÐ°ÑÑÐ²',
      ru: 'ÐÐ°Ð»ÑÐºÑÐ»ÑÑÐ¾Ñ ÑÑÑÐ°ÑÐ¾Ð²'
    },
    ico: 'fines_calculator',
    url: '/calculator/ff',
    helpUrl: 'HP160053',
    crmAlias: 'calculator_ff_access',
    crmAliasHide: 'calculator_ff_hide'
  },
  juridical_precedents: {
    id: 'juridical_precedents',
    name: {
      ua: 'CÑÐ´Ð¾Ð²Ñ Ð¿ÑÐµÑÐµÐ´ÐµÐ½ÑÐ¸',
      ru: 'CÑÐ´ÐµÐ±Ð½ÑÐµ Ð¿ÑÐµÑÐµÐ´ÐµÐ½ÑÑ'
    },
    ico: 'juridical_precedents',
    url: '/resource/judicial_precedents',
    helpUrl: 'HP160036',
    crmAlias: 'precedents',
    crmAliasHide: 'precedents_hide'
  },
  uz_web: {
    id: 'uz_web',
    name: {
      ua: 'Ð®Ð ÐÐ¡Ð¢&ÐÐÐÐÐ',
      ru: 'Ð®Ð ÐÐ¡Ð¢&ÐÐÐÐÐ'
    },
    ico: 'uz-web',
    type: {
      ua: '',
      ru: ''
    },
    url: '/resource-grid/cases_for_accountant',
    helpUrl: '',
    crmAlias: 'uz_web',
    crmAliasHide: ''
  },
  bz_web: {
    id: 'bz_web',
    name: {
      ua: 'ÐÐ£Ð¥ÐÐÐÐ¢ÐÐ &ÐÐÐÐÐ',
      ru: 'ÐÐ£Ð¥ÐÐÐÐ¢ÐÐ &ÐÐÐÐÐ'
    },
    ico: 'bz-web',
    type: {
      ua: '',
      ru: ''
    },
    url: '/resource-grid/cases_for_accountant',
    helpUrl: '',
    crmAlias: 'bz_web',
    crmAliasHide: ''
  },
  fz_web: {
    id: 'fz_web',
    name: {
      ua: 'ÐÐÐ¡ÐÐÐ ÐÐ¡Ð¤Ð',
      ru: 'ÐÐÐ¡Ð¢ÐÐÐ ÐÐ¡Ð¤Ð'
    },
    ico: 'fz-web',
    type: {
      ua: '',
      ru: ''
    },
    url: '/resource-grid/cases_for_accountant',
    helpUrl: '',
    crmAlias: 'fz_web',
    crmAliasHide: ''
  },
  ib: {
    id: 'ib',
    name: {
      ua: 'ÐÐÐ¢ÐÐ ÐÐÐ¢ÐÐÐÐ ÐÐ£Ð¥ÐÐÐÐ¢ÐÐ ÐÐ¯',
      ru: 'ÐÐÐ¢ÐÐ ÐÐÐ¢ÐÐÐÐÐ¯ ÐÐ£Ð¥ÐÐÐÐ¢ÐÐ ÐÐ¯'
    },
    ico: 'ib',
    type: {
      ua: '',
      ru: ''
    },
    url: '/resource-grid/cases_for_accountant',
    helpUrl: '',
    crmAlias: 'ib',
    crmAliasHide: ''
  },
  contractor: {
    id: 'contractor',
    name: {
      ua: 'CONTR AGENT',
      ru: 'CONTR AGENT'
    },
    ico: 'contractor',
    type: {
      ua: '',
      ru: ''
    },
    url: '/resource-grid/cases_for_accountant',
    helpUrl: '',
    crmAlias: 'contractor',
    crmAliasHide: ''
  },
  verdictum_web: {
    id: 'verdictum_web',
    name: {
      ua: 'VERDICTUM',
      ru: 'VERDICTUM'
    },
    ico: 'verdictum_web',
    type: {
      ua: '',
      ru: ''
    },
    url: '/resource-grid/cases_for_accountant',
    helpUrl: '',
    crmAlias: 'verdictum_web',
    crmAliasHide: ''
  },
  personalExpert: {
    id: 'personalExpert',
    name: {
      ua: 'ÐÐ¡ÐÐÐÐ¡Ð¢ÐÐ ÐÐÐ¡ÐÐÐ Ð¢',
      ru: 'ÐÐÐ§ÐÐ«Ð Ð­ÐÐ¡ÐÐÐ Ð¢'
    },
    ico: 'personalExpert',
    type: {
      ua: '',
      ru: ''
    },
    url: '/personalExpert',
    helpUrl: '',
    crmAlias: 'expert',
    crmAliasHide: ''
  },
  smsmayak: {
    id: 'smsmayak',
    name: {
      ua: 'SMS ÐÐÐ¯Ð',
      ru: 'SMS ÐÐÐ¯Ð'
    },
    ico: 'smsmayak',
    type: {
      ua: '',
      ru: ''
    },
    url: '/resource-grid/cases_for_accountant',
    helpUrl: '',
    crmAlias: 'smsmayak',
    crmAliasHide: ''
  },
  smsmayak_earth: {
    id: 'smsmayak_earth',
    name: {
      ua: 'SMS-ÐÐÐ¯Ð ÐÐÐÐÐ¯',
      ru: 'SMS-ÐÐÐ¯Ð ÐÐÐÐÐ¯'
    },
    ico: 'smsmayak',
    type: {
      ua: '',
      ru: ''
    },
    url: '/resource-grid/cases_for_accountant',
    helpUrl: '',
    crmAlias: 'smsmayak_earth',
    crmAliasHide: ''
  },
  semantrum_web: {
    id: 'semantrum_web',
    name: {
      ua: 'SEMANTRUM',
      ru: 'SEMANTRUM'
    },
    ico: 'semantrum_web',
    type: {
      ua: '',
      ru: ''
    },
    url: '/semantrum',
    helpUrl: '',
    crmAlias: 'semantrum_web',
    crmAliasHide: ''
  },
  ips_reporting: {
    id: 'ips_reporting',
    name: {
      ua: 'REPORT',
      ru: 'REPORT'
    },
    ico: 'reporting',
    type: {
      ua: '',
      ru: ''
    },
    url: '/reporting/',
    helpUrl: '',
    crmAlias: 'ips_reporting',
    crmAliasHide: ''
  },
  demo: {
    id: 'demo',
    name: {
      ua: 'ÐÐÐÐÐÐ¡Ð¢Ð ÐÐ¦ÐÐÐÐ ÐÐÐ Ð¡ÐÐ¯',
      ru: 'ÐÐÐÐÐÐ¡Ð¢Ð ÐÐ¦ÐÐÐÐÐÐ¯ ÐÐÐ Ð¡ÐÐ¯'
    },
    ico: 'demo',
    type: {
      ua: '',
      ru: ''
    },
    url: '',
    helpUrl: '',
    crmAlias: 'demo',
    crmAliasHide: ''
  },
  grand_excess: {
    id: 'grand_excess',
    name: {
      ua: 'ÐÐ ÐÐÐ',
      ru: 'ÐÐ ÐÐÐ'
    },
    ico: 'grand_excess',
    type: {
      ua: '',
      ru: ''
    },
    url: '',
    helpUrl: '',
    crmAlias: 'grand_excess',
    crmAliasHide: ''
  },
  configprime_lpr: {
    id: 'configprime_lpr',
    name: {
      ua: 'ÐÐ ÐÐÐ',
      ru: 'ÐÐ ÐÐÐ'
    },
    ico: 'configprime_lpr',
    type: {
      ua: '',
      ru: ''
    },
    url: '',
    helpUrl: '',
    crmAlias: 'configprime_lpr',
    crmAliasHide: ''
  },
  config_standart: {
    id: 'config_standart',
    name: {
      ua: 'ÐÐ£Ð¥ÐÐÐÐ¢ÐÐ  ÐÐ ÐÐ¤',
      ru: 'ÐÐ£Ð¥ÐÐÐÐ¢ÐÐ  ÐÐ ÐÐ¤'
    },
    ico: 'config_standart',
    type: {
      ua: '',
      ru: ''
    },
    url: '',
    helpUrl: '',
    crmAlias: 'config_standart',
    crmAliasHide: ''
  },
  lawyer_profi: {
    id: 'lawyer_profi',
    name: {
      ua: 'Ð®Ð ÐÐ¡Ð¢ ÐÐ ÐÐ¤',
      ru: 'Ð®Ð ÐÐ¡Ð¢ ÐÐ ÐÐ¤'
    },
    ico: 'lawyer_profi',
    type: {
      ua: '',
      ru: ''
    },
    url: '',
    helpUrl: '',
    crmAlias: 'lawyer_profi',
    crmAliasHide: ''
  },
  lawyer: {
    id: 'lawyer',
    name: {
      ua: 'Ð®Ð ÐÐ¡Ð¢',
      ru: 'Ð®Ð ÐÐ¡Ð¢'
    },
    ico: 'lawyer',
    type: {
      ua: '',
      ru: ''
    },
    url: '',
    helpUrl: '',
    crmAlias: 'lawyer',
    crmAliasHide: ''
  }
}
